<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "ShowAlert",
        props: {
            email: {
                type: String,
                default: ''
            }
        },
        mounted() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Heads Up...',
                html: ` Unfortunately your donation didn't go through. We have been notified of this error and we will get back to you with more details by emailing you at ${this.email}`
            });
        }
    }
</script>

<style scoped>

</style>
